import { DemoQuery, ResponseWithStatus } from '../constants/interfaces';
import { getRequest, postRequest } from 'Common/services/api';
import { Auth0ContextInterface } from '@auth0/auth0-react';

export const SQLMORPH_API_URL = '/sqlmorph/api';

export async function sqlConverter(
  auth0: Auth0ContextInterface,
  data: any
): Promise<ResponseWithStatus> {
  const response = await postRequest<Response>('v2/convert', {
    auth0: auth0,
    requestInit: {
      body: JSON.stringify(data),
    },
    transform: (r) => Promise.resolve(r),
    baseUrl: SQLMORPH_API_URL,
  });
  return { status: response.status, response: await response.json() };
}

export async function getSourcesTargets(): Promise<string> {
  return await getRequest('v1/sourcetargetmapping', {
    baseUrl: SQLMORPH_API_URL,
  });
}

export async function getDemoQueries(): Promise<{ demoQueries: DemoQuery[] }> {
  return await getRequest('v1/demo', {
    baseUrl: SQLMORPH_API_URL,
  });
}

export async function demoQueryConverter(
  auth0: Auth0ContextInterface,
  data: any
): Promise<ResponseWithStatus> {
  const response = await postRequest<Response>('v1/demo/convert', {
    auth0: auth0,
    requestInit: {
      body: JSON.stringify(data),
    },
    transform: (r) => Promise.resolve(r),
    baseUrl: SQLMORPH_API_URL,
  });
  return { status: response.status, response: await response.json() };
}
